import React from "react";
import { UserPlus } from "react-feather";
import { Col, Row } from "antd";

import DisplayCard from "../../DisplayCard/DisplayCard";

const Learnings = () => {
  return (
    <div className="site-card-wrapper">
      <Row gutter={16}>
        <Col span={12}>
          <DisplayCard
            icon={<UserPlus strokeWidth={1} size={16} />}
            heading="INVITE YOUR TEAM"
            title="Many hands make light work"
            description="You’ve got unlimited seats on every Hotjar plan. Bring your team onboard and get more eyes on what your users care about."
            buttonText="Invite Your Team"
          />
        </Col>
      </Row>
    </div>
  );
};

export default Learnings;
